import React, { PureComponent, ReactElement } from 'react';
import { DetailedSolution, TvImpact, TvImpactTypeEnum, TvMeteoAlert } from 'app/model/SOL49';
import { TVLoad } from 'app/components/dashboard/network/flows/TVLoad';
import AppContext from 'app/common/context/AppContext';
import { Flex } from 'app/components/common/Flex';
import { Popover } from 'antd';
import { PopoverMenu } from 'app/components/common/PopoverMenu';
import { MoreOutlined } from '@ant-design/icons';
import './TvLoadImpact.less';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { ShowModalEvent } from 'app/common/eventbus/Events';
import TvDetailsPanel from '../tv/TvDetailsPanel';
import { RegulationDto, TrafficType } from 'app/model/CORE';
import { TvCounts } from './TvCounts';
import MeasureUtils from 'app/common/util/MeasureUtils';
import { RegulationPeriods } from 'app/model/client/CORE';
import Utils from 'app/common/util/Utils';

interface TvLoadImpactProps {
    solution: DetailedSolution;
    meteoAlerts?: { [key: string]: Array<TvMeteoAlert> };
}

export class TvLoadImpact extends PureComponent<TvLoadImpactProps> {
    renderTvCounts = (tvImpact: TvImpact, regulationPeriods: RegulationPeriods[]) => {
        return (
            <TvCounts
                entryCounts={tvImpact?.entryCountsComparison?.counts}
                entryComparisonCounts={tvImpact?.entryCountsComparison?.comparisonCounts}
                entryTrafficType={TrafficType.LOAD}
                entryInterval={tvImpact.entryCountsComparison.counts.timeRange.countDurationInMinutes}
                entryStep={60}
                occCounts={tvImpact?.occupancyCountsComparison?.counts}
                occComparisonCounts={tvImpact?.occupancyCountsComparison?.comparisonCounts}
                occTrafficType={TrafficType.LOAD}
                otmvDuration={tvImpact?.occupancyCountsComparison?.counts?.request?.durationInMin}
                loadValues={tvImpact.monitoredTv.loadValues}
                occupancyLoadValues={tvImpact.monitoredTv.occupancyLoadValues}
                regulationPeriods={regulationPeriods}
                meteoAlerts={this.props.meteoAlerts?.[tvImpact.tvId]}
                currentTime={AppContext.getCurrentTime()}
                tvId={tvImpact.tvId}
                tvSet={''}
                hideSettings={true}
            />
        );
    };

    render() {
        return (
            <Flex direction="vertical" grow={false} className="tv-load-impact">
                <span className="header">TFV LOAD</span>
                <div className="load-impact">
                    {/*<Flex grow={false} className='load-impact'>*/}
                    {this.props.solution.solutionImpact?.tvImpact
                        .filter(
                            tvImpact =>
                                Utils.isNotExists(tvImpact.type) || tvImpact.type === TvImpactTypeEnum.SELECTION,
                        )
                        .map(tvImpact => {
                            const monitoredTv = tvImpact?.monitoredTv;
                            const tvMeasures: RegulationDto[] = this.props.solution.measures
                                .filter(
                                    measure => monitoredTv.refLocation.id === MeasureUtils.getTvLocation(measure).id,
                                )
                                .filter(measure => MeasureUtils.isRegulationOrMcdmOnly(measure));

                            const regulationPeriods = tvMeasures.map(regulation =>
                                MeasureUtils.getRegulationPeriods(regulation),
                            );

                            const occupancyPeriods = undefined; //this.props.tvsOccupancyPeriods?.[monitoredTv.refLocation.id]
                            return (
                                <Popover
                                    key={`tv-load-impact-${tvImpact.tvId}-${this.props.solution.name}`}
                                    content={this.renderTvCounts(tvImpact, regulationPeriods)}
                                    placement="rightBottom"
                                    overlayInnerStyle={{ width: '50em' }}>
                                    <div className="tv-load">
                                        <TVLoad
                                            key={monitoredTv.refLocation.id}
                                            tvName={monitoredTv.refLocation.id}
                                            vsName={undefined}
                                            elementary={monitoredTv.elementary}
                                            simulated={true}
                                            entryLoad={monitoredTv.loadValues}
                                            occupancyLoad={monitoredTv.occupancyLoadValues}
                                            monitoredMeasures={undefined}
                                            activePeriods={monitoredTv.activePeriods}
                                            occupancyPeriods={occupancyPeriods}
                                            currentTime={AppContext.getCurrentTime()}
                                            monitorable={monitoredTv.monitorable}
                                            selected={false}
                                            onSelectionChange={undefined}
                                            moreMenu={
                                                <TvImpactMoreMenu
                                                    tvImpact={tvImpact}
                                                    tvCounts={this.renderTvCounts(tvImpact, regulationPeriods)}
                                                />
                                            }
                                        />
                                    </div>
                                </Popover>
                            );
                        })}
                    {/*</Flex>*/}
                </div>
            </Flex>
        );
    }
}

class TvImpactMoreMenu extends PureComponent<{ tvImpact: TvImpact; tvCounts: ReactElement }> {
    handleMoreMenuItemClick = (key: string) => {
        switch (key) {
            case 'show-details':
                AppContext.eventBus.publish(
                    new ShowModalEvent(ShowModalEvent.NAME, this.props.tvCounts, TvDetailsPanel.INITIAL_WIDTH),
                );
                break;
        }
    };
    getMenuItems = (): ItemType[] => {
        return [{ key: 'show-details', label: 'Show details (graphs)' }];
    };

    render() {
        return (
            <PopoverMenu onMenuItemClick={this.handleMoreMenuItemClick} menuItems={this.getMenuItems()}>
                <MoreOutlined />
            </PopoverMenu>
        );
    }
}
